import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import { hiddenDown } from '@twistopayments/design-system/styles'
import NextImage from 'next/image'

import type { SectionsContactComponent } from '@twisto/api-cms'

import { useHighlightedText } from 'homepage/libs/hooks'

import { Form } from '../../form'

import * as styles from './contact.styles'
import formBg from './form-bg.png'

export const Contact = ({
  title,
  highlighted,
  description,
  theme,
  inputs,
  submit,
}: SectionsContactComponent) => {
  const { before, highlight, after } = useHighlightedText(title, highlighted)

  return (
    <section css={[styles.section, theme === 'dark' && styles.dark]}>
      <div css={styles.content}>
        <div>
          <Typography css={styles.title} fontWeight="heavy" variant="h2">
            {before}
            <span css={styles.highlighted}>{highlight}</span>
            {after}
          </Typography>
          <p css={styles.description}>{description}</p>
        </div>
        <div css={styles.formWrapper}>
          {theme === 'dark' && (
            <div css={hiddenDown('smMd')}>
              <NextImage
                alt="Background figure"
                css={styles.formBg}
                src={formBg}
              />
            </div>
          )}
          <Form
            formStyles={styles.form}
            inputs={inputs}
            submit={submit}
            submitType="link"
          />
        </div>
      </div>
    </section>
  )
}
